import { NEW_AWARD } from "../../routes";

/** What another page hands New Award in router state: the Award's name to start with. */
export type AwardHandover = { title?: string };

/** New Award's router state, read on arrival; anything else is no handover. */
export const readAwardHandover = (state: unknown): AwardHandover => {
  const { title } = (state ?? {}) as AwardHandover;
  return typeof title === "string" && title.trim() ? { title: title.trim() } : {};
};

export const toNewAward = (handover: AwardHandover = {}) => ({
  pathname: NEW_AWARD,
  state: handover,
});
